import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Buttons or controls aligned to the right of the title. */
  actions?: React.ReactNode;
}

/**
 * The one place a dashboard page title is defined. Every page previously
 * re-implemented this, which is how three of them drifted to font-semibold
 * while the other fourteen used font-bold.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <div className="flex flex-wrap items-start justify-between gap-4">
    <div className="min-w-0">
      <h1 className="text-title-lg text-content">{title}</h1>
      {subtitle && <p className="mt-1 text-body text-content-muted max-w-prose">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
